import { render, staticRenderFns } from "./SystemTagRichArgument.vue?vue&type=template&id=7e2ba972&scoped=true"
import script from "./SystemTagRichArgument.vue?vue&type=script&lang=js"
export * from "./SystemTagRichArgument.vue?vue&type=script&lang=js"
import style0 from "./SystemTagRichArgument.vue?vue&type=style&index=0&id=7e2ba972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ba972",
  null
  
)

export default component.exports